module.exports = __webpack_public_path__ + "img/ESTJ.7b28c4e4.png";